/** Shown wherever a figure cannot be derived, so every key-insight card reads the same. */
export const NO_VALUE = "-";

/** A scenario header figure waiting on a recalculation; wider than NO_VALUE so it reads at header size. */
export const STALE_VALUE = "—";

/** The five measures, in the order the section renders them. */
export const SIDE_BY_SIDE_ROW_KEYS = ["totalMargin", "extraVsBaseline", "yearsBehind", "deepestDip", "resilience"] as const;

export type SideBySideRowKey = (typeof SIDE_BY_SIDE_ROW_KEYS)[number];

// < 3 crops → no AI insight fetch, and no resilience score (the API excludes the scenario entirely)
export const RESILIENCE_UNLOCK_MIN_CROPS = 3;
